export default [{
        path: '/guide/info',
        name: 'guideInfo',
        meta: {
            title: '导游',
            keepAlive: true
        },
        component: () =>
            import (
                /* webpackChunkName: "purinfo" */
                '../../pages/guideSystem/guideInfo.vue'
            )
    },
    {
        path: '/guide/index',
        meta: {
            title: '导游'
        },
        component: () =>
            import (
                /* webpackChunkName: "purindex" */
                '../../pages/guideSystem/index.vue'
            )
    },
    {//待办
        path: '/guide/todoList',
        meta: {
            title: '待办事项'
        },
        component: () =>
            import (
                /* webpackChunkName: "purchtodoList" */
                '../../pages/guideSystem/todoList.vue'
            )
    },
    {
        path: '/guide/guideList',
        meta: {
            title: '导游'
        },
        component: () =>
            import (
                /* webpackChunkName: "purguideList" */
                '../../pages/guideSystem/guideList.vue'
            )
    },
    {
        path: '/guide/evaluate',
        meta: {
            title: '评分详情',
            keepAlive: true
        },
        component: () =>
            import (
                /* webpackChunkName: "purevaluate" */
                '../../pages/guideSystem/integrityIndex.vue'
            )
    },
    {
        path: '/guide/blacklist',
        meta: {
            title: '黑名单监管明细'
        },
        component: () =>
            import (
                /* webpackChunkName: "purblacklist" */
                '../../pages/guideSystem/blacklistDisposal.vue'
            )
    },
    {
        path: '/guide/education',
        meta: {
            title: '学历信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "pureducation" */
                '../../pages/guideSystem/education.vue'
            )
    },
    {
        path: '/guide/photo',
        meta: {
            title: '图片'
        },
        component: () =>
            import (
                /* webpackChunkName: "purphoto" */
                '../../pages/guideSystem/documentPhoto.vue'
            )
    },
    {
        path: '/guide/infoList',
        meta: {
            title: '奖惩信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "purinfoList" */
                '../../pages/guideSystem/infoList.vue'
            )
    },
    {
        path: '/guide/awardDetail',
        meta: {
            title: '奖惩信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "purawardDetail" */
                '../../pages/guideSystem/awardDetail.vue'
            )
    },
    {
        path: '/guide/penaltyDetail',
        meta: {
            title: '奖惩信息'
        },
        component: () =>
            import (
                /* webpackChunkName: "purpenaltyDetail" */
                '../../pages/guideSystem/penaltyDetail.vue'
            )
    }, {
        path: '/guide/itinerary',
        meta: {
            title: '行程单'
        },
        component: () =>
            import (
                /* webpackChunkName: "puritinerary" */
                '../../pages/guideSystem/itinerary.vue'
            )
    },
    {
        path: '/guide/areaUpdate',
        meta: {
            title: '区域变更记录'
        },
        component: () =>
            import (
                /* webpackChunkName: "purareaUpdate" */
                '../../pages/guideSystem/areaUpdate.vue'
            )
    },
    {
        path: '/guide/supervision',
        meta: {
            title: '重点关注明细'
        },
        component: () =>
            import (
                /* webpackChunkName: "pursupervision" */
                '../../pages/guideSystem/supervisionDetail.vue'
            )
    },
    {
        path: '/guide/upload',
        meta: {
            title: ''
        },
        component: () =>
            import (
                /* webpackChunkName: "purupload" */
                '../../pages/guideSystem/uploadFiles.vue'

            )
    },
    {
        path: '/guide/search',
        meta: {
            title: '导游'
        },
        component: () =>
            import (
                /* webpackChunkName: "pursearch" */
                '../../pages/guideSystem/search.vue'

            )
    },
    {
        path: '/guide/uploadScore',
        meta: {
            title: '上传评分材料'
        },
        component: () =>
            import (
                /* webpackChunkName: "puruploadScore" */
                '../../pages/guideSystem/uploadScoreFiles.vue'

            )
    },
    {
        path: '/guide/exitBlacklist',
        name: 'exitBlacklist',
        meta: {
            title: '退出黑名单',
	        unwantedSetTitle: true
        },
        component: () =>
            import (
                /* webpackChunkName: "puruploadScore" */
                '../../pages/guideSystem/exitBlacklist.vue'

            )
    },
    {
        path: '/guide/noPass',
        meta: {
            title: '审核不通过'
        },
        component: () =>
            import (
                /* webpackChunkName: "puruploadScore" */
                '../../pages/guideSystem/noPass'

            )
    },
    {
        path: '/guide/guiding',
        name: 'guiding',
        meta: {
            title: '',
	        unwantedSetTitle: true
        },
        component: () =>
            import (
                /* webpackChunkName: "puruploadScore" */
                '../../pages/guideSystem/guiding.vue'

            )
    },
    {
        path: '/guide/material',
        meta: {
            title: ''
        },
        component: () =>
            import (
                /* webpackChunkName: "purmaterial" */
                '../../pages/guideSystem/material.vue'

            )
    },
    {
        path: '/guide/uploadMaterial',
        meta: {
            title: '上传评分材料'
        },
        component: () =>
            import (
                /* webpackChunkName: "puruploadMaterial" */
                '../../pages/guideSystem/uploadMaterial.vue'

            )
    },
    {
        path: '/guide/complaintlList',
        meta: {
            title: '投诉列表'
        },
        component: () =>
            import (
                /* webpackChunkName: "purcomplaintlList" */
                '../../pages/guideSystem/complaintlList.vue'

            )
    }
]
